module.exports = __webpack_public_path__ + "img/14.b108c907.jpg";